export const table = [
  { value: "addresses", label: "Addresses" },
  { value: "admins", label: "Admins" },
  { value: "user", label: "Users" },
  { value: "homes", label: "Homes" },
  // { value: "permissions", label: "Permissions" },
  // { value: "roles", label: "Roles" },
  { value: "transactions", label: "Transactions" },
  { value: "reports", label: "Reports" },
];

export const profession = [
  { value: "accountant", label: "Accountant" },
  { value: "actor/actress", label: "Actor/Actress" },
  { value: "advisor", label: "Advisor" },
  { value: "advocate", label: "Advocate" },
  { value: "agent", label: "Agent" },
  { value: "ambassador", label: "Ambassador" },
  { value: "animator", label: "Animator" },
  { value: "architect", label: "Architect" },
  { value: "artist", label: "Artist" },
  { value: "astrologer", label: "Astrologer" },
  { value: "author", label: "Author" },
  { value: "babysitter", label: "Babysitter" },
  { value: "banker", label: "Banker" },
  { value: "barber", label: "Barber" },
  { value: "bartender", label: "Bartender" },
  { value: "bookkeeper", label: "Bookkeeper" },
  { value: "boxer", label: "Boxer" },
  { value: "brand ambassador", label: "Brand Ambassador" },
  { value: "bricklayer", label: "Bricklayer" },
  { value: "builder", label: "Builder" },
  { value: "bus driver", label: "Bus driver" },
  { value: "businessman/woman", label: "Businessman/woman" },
  { value: "butcher", label: "Butcher" },
  { value: "cameraman/woman", label: "Cameraman/woman" },
  { value: "cardiologist", label: "Cardiologist" },
  { value: "carpenter", label: "Carpenter" },
  { value: "cashier", label: "Cashier" },
  { value: "chartered accountant", label: "Chartered Accountant" },
  { value: "chef", label: "Chef" },
  { value: "cleaner", label: "Cleaner" },
  { value: "coach", label: "Coach" },
  { value: "coder", label: "Coder" },
  { value: "comedian", label: "Comedian" },
  { value: "composer", label: "Composer" },
  { value: "construction worker", label: "Construction Worker" },
  { value: "consultant", label: "Consultant" },
  { value: "cook", label: "Cook" },
  { value: "dancer", label: "Dancer" },
  { value: "dentist", label: "Dentist" },
  { value: "designer", label: "Designer" },
  { value: "detective", label: "Detective" },
  { value: "developer", label: "Developer" },
  { value: "director", label: "Director" },
  { value: "doctor", label: "Doctor" },
  { value: "doorman/woman", label: "Doorman/woman" },
  { value: "driver", label: "Driver" },
  { value: "economist", label: "Economist" },
  { value: "editor", label: "Editor" },
  { value: "electrician", label: "Electrician" },
  { value: "engineer", label: "Engineer" },
  { value: "entrepreneur", label: "Entrepreneur" },
  { value: "factory worker", label: "Factory Worker" },
  { value: "farmer", label: "Farmer" },
  { value: "fashion designer", label: "Fashion Designer" },
  { value: "filmmaker", label: "Filmmaker" },
  { value: "fire fighter", label: "Fire Fighter" },
  { value: "fireman/woman", label: "Fireman/woman" },
  { value: "fisherman", label: "Fisherman" },
  { value: "footballer", label: "Footballer" },
  { value: "forest ranger", label: "Forest Ranger" },
  { value: "game designer", label: "Game Designer" },
  { value: "gamer", label: "Gamer" },
  { value: "gardener", label: "Gardener" },
  { value: "guard", label: "Guard" },
  { value: "hairdresser", label: "Hairdresser" },
  { value: "housekeeper", label: "Housekeeper" },
  { value: "housewife", label: "Housewife" },
  { value: "investigator", label: "Investigator" },
  { value: "investor", label: "Investor" },
  { value: "it manager", label: "IT Manager" },
  { value: "jeweler", label: "Jeweler" },
  { value: "journalist", label: "Journalist" },
  { value: "judge", label: "Judge" },
  { value: "landlord", label: "Landlord" },
  { value: "lawyer", label: "Lawyer" },
  { value: "lecturer", label: "Lecturer" },
  { value: "legal advisor", label: "Legal Advisor" },
  { value: "lifeguard", label: "Lifeguard" },
  { value: "lyricist", label: "Lyricist" },
  { value: "magician", label: "Magician" },
  { value: "maid", label: "Maid" },
  { value: "make-up artist", label: "Make-up Artist" },
  { value: "management professional", label: "Management Professional" },
  { value: "marketer", label: "Marketer" },
  { value: "messenger", label: "Messenger" },
  { value: "midwife", label: "Midwife" },
  { value: "model", label: "Model" },
  { value: "monk", label: "Monk" },
  { value: "musician", label: "Musician" },
  { value: "novelist", label: "Novelist" },
  { value: "nurse", label: "Nurse" },
  { value: "nutritionist", label: "Nutritionist" },
  { value: "optician", label: "Optician" },
  { value: "painter", label: "Painter" },
  { value: "performer", label: "Performer" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "philosopher", label: "Philosopher" },
  { value: "photographer", label: "Photographer" },
  { value: "physician", label: "Physician" },
  { value: "pilot", label: "Pilot" },
  { value: "plumber", label: "Plumber" },
  { value: "podcaster", label: "Podcaster" },
  { value: "poet", label: "Poet" },
  { value: "policeman/woman", label: "Policeman/woman" },
  { value: "politician", label: "Politician" },
  { value: "postman/woman", label: "Postman/woman" },
  { value: "priest", label: "Priest" },
  { value: "principal", label: "Principal" },
  { value: "private detective", label: "Private Detective" },
  { value: "professor", label: "Professor" },
  { value: "programmer", label: "Programmer" },
  { value: "psychologist", label: "Psychologist" },
  { value: "publisher", label: "Publisher" },
  { value: "real estate agent", label: "Real Estate Agent" },
  { value: "receptionist", label: "Receptionist" },
  { value: "repairer", label: "Repairer" },
  { value: "repairman", label: "Repairman" },
  { value: "reporter", label: "Reporter" },
  { value: "researcher", label: "Researcher" },
  { value: "salesman", label: "Salesman" },
  { value: "scientist", label: "Scientist" },
  { value: "secretary", label: "Secretary" },
  { value: "security guard", label: "Security Guard" },
  { value: "shopkeeper", label: "Shopkeeper" },
  { value: "singer", label: "Singer" },
  { value: "sketch artist", label: "Sketch Artist" },
  { value: "software developer", label: "Software Developer" },
  { value: "soldier", label: "Soldier" },
  { value: "student", label: "Student" },
  { value: "stuntman", label: "Stuntman" },
  { value: "stylist", label: "Stylist" },
  { value: "surgeon", label: "Surgeon" },
  { value: "tailor", label: "Tailor" },
  { value: "taxi driver", label: "Taxi Driver" },
  { value: "teacher", label: "Teacher" },
  { value: "therapist", label: "Therapist" },
  { value: "translator", label: "Translator" },
  { value: "travel agent", label: "Travel agent" },
  { value: "tutor", label: "Tutor" },
  { value: "undertaker", label: "Undertaker" },
  { value: "veterinary doctor", label: "Veterinary Doctor" },
  { value: "videographer", label: "Videographer" },
  { value: "vlogger", label: "Vlogger" },
  { value: "waiter/waitress", label: "Waiter/Waitress" },
  { value: "window cleaner", label: "Window Cleaner" },
  { value: "writer", label: "Writer" },
  { value: "youtuber", label: "Youtuber" },
];

export const dateConstant = [...new Array(20)];
